/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from "immutable";
import { bindActionCreators } from 'redux'
import { toast } from 'react-toastify';
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from '../../infra/components/formInput/ComboboxInput'

import ActionSubmit from '../../store/action/WaProfileSetting/Set'
import ActionUpload from '../../store/action/WaProfileSetting/SetImageProfile'
import ActionGet from '../../store/action/WaProfileSetting/Fetch'
import ActionGetImage from '../../store/action/WaProfileSetting/FetchImageUrl'
import ActionGetAllClient from "../../store/action/Client/FetchAll"
import ActionGetAllSender from '../../store/action/Sender/FetchAll'
import ActionGetAllDivision from '../../store/action/Division/FetchAll'
import { DivisionId, SenderId, ClientId,PrevilageId } from "../../helper/HelperAuth";

class Form extends Component {

  constructor(props) {
    super(props);
    this.state = {
      form: fromJS({
        "client-id": "",
        "division-id": '',
        "sender-id": "",
        "about": "",
        "address": "",
        "description": "",
        "email": "",
        "vertical": "",
        "website": "",
      }),
      hideimage:'',
      clientdis:'',
      divisiondis:'',
      senderdis:'',
      formIsUpdated: false,
      errors: fromJS({}),
      vertical: fromJS({
        1: { value: 'Education', label: 'Education' },
        2: { value: 'Automotive', label: 'Automotive' },
        3: { value: 'Beauty, Spa and Salon', label: 'Beauty, Spa and Salon' },
        4: { value: 'Entertainment', label: 'Entertainment' },
        5: { value: 'Event Planning and Service', label: 'Event Planning and Service' },
        6: { value: 'Finance and Banking', label: 'Finance and Banking' },
        7: { value: 'Food and Grocery', label: 'Food and Grocery' },
        8: { value: 'Public Service', label: 'Public Service' },
        9: { value: 'Hotel and Lodging', label: 'Hotel and Lodging' },
        10: { value: 'Medical and Health', label: 'Medical and Health' },
        11: { value: 'Non-profit', label: 'Non-profit' },
        12: { value: 'Professional Services', label: 'Professional Services' },
        13: { value: 'Shopping and Retail', label: 'Shopping and Retail' },
        14: { value: 'Travel and Transportation', label: 'Travel and Transportation' },
        15: { value: 'Restaurant', label: 'Restaurant' },
        16: { value: 'Other', label: 'Other' },




      }),
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnFileChanged = this.handleOnFileChanged.bind(this)
    this.handleChangePhoto = this.handleChangePhoto.bind(this)
  }

 async componentDidMount() {
  if(PrevilageId != 1){
    this.setState({clientdis:"disabled",divisiondis:"disabled",senderdis:"disabled"})
  }
   this.props.actionGet(SenderId);
   var res = await this.props.actionGetImage(SenderId);
    if(!(res.ok)){
      this.setState({hideimage:"hide"})
    }
 this.props.actionGetAllClient();
 this.props.actionGetAllDivision(ClientId)
 this.props.actionGetAllSender(ClientId, DivisionId)
  }

  async handleChange(field, value) {
    var formVal = this.state.form;
    formVal = formVal.set(field, value);
    if (field === 'client-id') {
      formVal = formVal.set('sender-id', '')
      formVal = formVal.set('division-id', '')
      this.props.actionGetAllDivision(value)
      this.props.actionGetAllSender(value)
      if (value == "" || value == null || value != ClientId) {
        this.setState({hideimage:'hide'})
        formVal = formVal.set('about', "")
        formVal = formVal.set('address', "")
        formVal = formVal.set('description', "")
        formVal = formVal.set('email', "")
        formVal = formVal.set('vertical', "")
        formVal = formVal.set('website', "")
      }
      this.setState({ form: formVal })
    }

    if (field === 'division-id') {
      var client = this.state.form.get("client-id")
      this.props.actionGetAllSender(client,value)
      if (value == "" || value == null) {
        formVal = formVal.set('about', "")
        formVal = formVal.set('address', "")
        formVal = formVal.set('description', "")
        formVal = formVal.set('email', "")
        formVal = formVal.set('vertical', "")
        formVal = formVal.set('website', "")
      }
      this.setState({ form: formVal })
    }
    if (field === 'sender-id') {
      const about = await this.props.actionGet(value);
      if (about.ok && (formVal.get("sender-id") != "" && formVal.get("sender-id") != null)) {
        const image = await this.props.actionGetImage(value);
        if(!(image.ok)){
          this.setState({hideimage:"hide"})
        }else{
          this.setState({hideimage:""})
        }
        formVal = formVal.set('about', this.props.waprofilesetting.get('about'))
        formVal = formVal.set('address', this.props.waprofilesetting.get('address'))
        formVal = formVal.set('description', this.props.waprofilesetting.get('description'))
        formVal = formVal.set('email', this.props.waprofilesetting.get('email'))
        formVal = formVal.set('vertical', this.props.waprofilesetting.get('vertical'))
        if (this.props.waprofilesetting.get('websites') != undefined) {
          formVal = formVal.set('website', this.props.waprofilesetting.get('websites').get(0))
        } else {
          formVal = formVal.set('website', "")
        }
        this.setState({ form: formVal })
      } else {
        const image = await this.props.actionGetImage(value);
        if(!(image.ok)){
          this.setState({hideimage:"hide"})
        }else{
          this.setState({hideimage:""})
        }
        formVal = formVal.set('about', "")
        formVal = formVal.set('address', "")
        formVal = formVal.set('description', "")
        formVal = formVal.set('email', "")
        formVal = formVal.set('vertical', "")
        formVal = formVal.set('website', "")
      }
      this.setState({ form: formVal })
    }
    this.setState({ form: formVal })
  }

  async handleOnFileChanged() {

    var sender = this.state.form.get("sender-id")
    if (sender == null || sender == "" || sender == undefined) {
      toast.error("Sender Cannot Be Empty", toast.POSITION.TOP_RIGHT);
    return false
    }
   
    var file = event.target.files[0]
    var response = await this.props.actionUpload(file, sender);
    if (response.ok) {
      const image = await this.props.actionGetImage(sender);;
      if(!(image.ok)){
        this.setState({hideimage:"hide"})
      }else{
        this.setState({hideimage:""})
      }
      toast.success("Change Image Success!", toast.POSITION.TOP_RIGHT);
    } else {
      toast.error("Save Failed!", toast.POSITION.TOP_RIGHT);
    }
  }

  handleChangePhoto() {
    this.refs.fileUploader.click();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.waprofilesetting != null && state.oldwaprofilesetting !== props.waprofilesetting && props.waprofilesetting.size > 0) {
      //debugger;

      return {
        form: fromJS({
          "client-id": ClientId,
          "division-id": DivisionId,
          "sender-id": SenderId,
          "about": props.waprofilesetting.get('about'),
          "address": props.waprofilesetting.get('address'),
          "description": props.waprofilesetting.get('description'),
          "email": props.waprofilesetting.get('email'),
          "vertical": props.waprofilesetting.get('vertical'),
          "website": props.waprofilesetting.get('websites') !== undefined ? props.waprofilesetting.get('websites').get(0) : "",
        }),
        oldwaprofilesetting: props.waprofilesetting
      }
    }
    return null;
  }

  async handleSubmit(dispatch) {
    const form = this.state.form;
    var sender = this.state.form.get("sender-id")
    if (sender == '' || sender == null || sender == undefined) {
      this.setState({ error: "Sender cannot be empty!" });
      toast.error('Sender cannot be empty!', toast.POSITION.TOP_RIGHT);

      return false;
    }
    // if (sender == null || sender == "" || sender == undefined) {
    //   sender = SenderId
    // }
    var data =
    {
      "about":  form.get('about'),
      "address": form.get('address'),
      "description": form.get('description'),
      "email": form.get('email'),
      "vertical": form.get('vertical'),
      "websites": [
        form.get('website'),
      ]
    }
    var file = this.state.form.get('selected-file')
    var response = await this.props.actionSubmit(data, file, sender);
    if (response.ok) {
      toast.success("Save Success!", toast.POSITION.TOP_RIGHT);
      //this.props.handleCancelForm(true); 
    } else {
    }
  }

  render() {
    const { form, errors, disabled, vertical ,hideimage,clientdis,divisiondis,senderdis} = this.state;
    return (
      <div className="clearfix">
        <div className="card-noborder">
          <h4>
            Detail Profiles
          </h4>
        </div>

        <div className="margin-top-min">
          <div className="col-xs-12 col-sm-3 noleftpadding norightpadding">
            <div className="card profile-card">
              <div className="profile-header">
                <div className={`image-area ${hideimage}`}>
                  <img src={this.props.waprofileimage} style={{ width: "150px", height: "150px" }}  ></img>
                </div>
              </div>
              <div className="profile-footer">
                <input ref="fileUploader"
                  type="file"
                  name="file"
                  onChange={this.handleOnFileChanged}
                  style={{ display: "none" }}
                />
                <button className="btn btn-primary btn-lg waves-effect btn-block" onClick={this.handleChangePhoto} >Change Photo</button>
              </div>
            </div>
          </div>

          <div className="col-xs-12 col-sm-9 noleftpadding norightpadding">
            <div className="card">
              <div className="body">
                <div className="form-group row">
                  <span className="col-sm-2">Client</span>
                  <div className="col-sm-10">
                    <ComboboxInput
                      field='client-id'
                      value={form.get('client-id')}
                      options={fromJS({
                        'source': this.props.clientall,
                        'value': 'client-id',
                        'label': 'client-name'
                      })}
                      onChange={(field, value, label) => this.handleChange(field, value)}
                      placeholder="Client"
                      disabled={clientdis}
                      hasError={errors.has('client')}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <span className="col-sm-2">Division</span>
                  <div className="col-sm-10">
                    <ComboboxInput
                      field='division-id'
                      value={form.get('division-id')}
                      options={fromJS({
                        'source': this.props.divisionall,
                        'value': 'division-id',
                        'label': 'division-name'
                      })}
                      onChange={(field, value, label) => this.handleChange(field, value)}
                      placeholder="Division"
                      disabled={divisiondis}
                      hasError={errors.has('division-id')}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <span className="col-sm-2">Sender</span>
                  <div className="col-sm-10">
                    <ComboboxInput
                      field='sender-id'
                      value={form.get('sender-id')}
                      options={fromJS({
                        'source': this.props.senderall,
                        'value': 'sender-id',
                        'label': 'sender-name'
                      })}
                      onChange={(field, value, label) => this.handleChange(field, value)}
                      placeholder="Sender"
                      disabled={senderdis}
                      hasError={errors.has('sender-id')}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <span className="col-sm-2">About</span>
                  <div className="col-sm-10">
                    <TextInputField className="form-control"
                      field={'about'}
                      value={form.get('about')}
                      onChange={(field, value) => this.handleChange(field, value)}
                      placeholder="about"
                      disabled={disabled}
                      hasError={errors.has('about')}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <span className="col-sm-2">Description</span>
                  <div className="col-sm-10">
                    <TextInputField className="form-control"
                      textarea
                      field={'description'}
                      value={form.get('description')}
                      onChange={(field, value) => this.handleChange(field, value)}
                      placeholder="description"
                      disabled={disabled}
                      hasError={errors.has('description')}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <span className="col-sm-2">Address</span>
                  <div className="col-sm-10">
                    <TextInputField className="form-control"
                      textarea
                      field={'address'}
                      value={form.get('address')}
                      onChange={(field, value) => this.handleChange(field, value)}
                      placeholder="address"
                      disabled={disabled}
                      hasError={errors.has('address')}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <span className="col-sm-2">Email</span>
                  <div className="col-sm-10">
                    <TextInputField className="form-control"
                      field={'email'}
                      value={form.get('email')}
                      onChange={(field, value) => this.handleChange(field, value)}
                      placeholder="email"
                      disabled={disabled}
                      hasError={errors.has('email')}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <span className="col-sm-2">Vertical</span>
                  <div className="col-sm-10">
                    <ComboboxInput
                      field='vertical'
                      value={form.get('vertical')}
                      options={fromJS({
                        'source': vertical,
                        'value': 'value',
                        'label': 'label'
                      })}
                      onChange={(field, value, label) => this.handleChange(field, value)}
                      placeholder="Vertical"
                      disabled={this.state.disabled}
                      hasError={errors.has('vertical')}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <span className="col-sm-2">Website</span>
                  <div className="col-sm-10">
                    <TextInputField className="form-control"
                      field={'website'}
                      value={form.get('website')}
                      onChange={(field, value) => this.handleChange(field, value)}
                      placeholder="website"
                      disabled={disabled}
                      hasError={errors.has('website')}
                    />
                  </div>
                </div>

                <div className="form-group row">
                  <span className="col-sm-2"></span>
                  <div className="col-sm-10">
                    <button type="button"
                      className="btn btn-success btn-wide waves-effect"
                      onClick={this.handleSubmit}>
                      Save
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


export default connect(
  (state) => {
    return {
      clientall: state.user.clientall,
      divisionall: state.user.divisionall,
      senderall: state.user.senders,
      waprofilesetting: state.user.waprofilesetting,
      waprofileimage: state.user.waprofileimage,
    }
  },
  dispatch => bindActionCreators({
    actionGetAllClient: ActionGetAllClient,
    actionGetAllDivision: ActionGetAllDivision,
    actionGetAllSender: ActionGetAllSender,
    actionSubmit: ActionSubmit,
    actionUpload: ActionUpload,
    actionGet: ActionGet,
    actionGetImage: ActionGetImage,
  }, dispatch),
)(Form);


